import { Box, Button, Modal } from "@mui/material"
import { WarningAmber } from '@mui/icons-material';
import { useState, useEffect } from 'react';

export const ConfirmationWarning = ({submitFormLoader, submitHandler}) => {
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        if (!submitFormLoader.modal && isExiting) {
            const timer = setTimeout(() => setIsExiting(false), 300);
            return () => clearTimeout(timer);
        }
    }, [submitFormLoader.modal, isExiting]);

    const handleClose = () => {
        setIsExiting(true);
        submitHandler('cancel');
    };

    if (!submitFormLoader.modal && !isExiting) return null;

    return (
        <Modal open={submitFormLoader.modal} onClose={handleClose} sx={{zIndex:1304}} className="noutlined" disableEnforceFocus disableAutoFocus disableRestoreFocus closeAfterTransition>
            <Box height="100vh" width="100vw" position="fixed" top={0} left={0} display="flex" justifyContent="center" alignItems="center" px={2} sx={{ outline: 'none', backdropFilter: 'blur(8px)', bgcolor: 'rgba(255, 255, 255, 0.1)' }}>
                <Box width={'100%'} maxWidth="600px" bgcolor="#FFFFFF" px="24px" pb="24px" borderRadius="6px" sx={{ outline: 'none' }}>
                    <Box minHeight="52px"></Box>
                    <Box display="flex" flexDirection="column" gap="20px">
                        <WarningAmber/>
                        <Box color="#292C2F" fontSize={16} fontWeight={600} lineHeight="20px">Proceed with Saving the Data?</Box>
                        <Box color="#5B6167" fontSize={14} fontWeight={400} lineHeight="21px">Once Saved, No Further Edits Can Be Made.</Box>
                        <Box display="flex" alignItems="center" minHeight={40}>
                            <Button disabled={submitFormLoader.loader} fullWidth variant="outlined" onClick={handleClose} sx={{mr: 1, height: 40, borderRadius: '6px', bgcolor: '#E2EDE7', '&:hover':{bgcolor: '#A4CAB4'}}}>Cancel</Button>
                            <Button disabled={submitFormLoader.loader} fullWidth variant='contained' disableElevation onClick={()=>submitHandler('save')} sx={{height: 40, borderRadius: '6px'}}>Save</Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}